import type React from "react";
import {
  Avatar as ShadcnAvatar,
  AvatarImage as ShadcnAvatarImage,
  AvatarFallback as ShadcnAvatarFallback,
  AvatarBadge as ShadcnAvatarBadge,
  AvatarGroup as ShadcnAvatarGroup,
  AvatarGroupCount as ShadcnAvatarGroupCount,
} from "src/shadcn/components/avatar";

const Avatar = (props: React.ComponentProps<typeof ShadcnAvatar>) => (
  <ShadcnAvatar {...props} />
);

const AvatarImage = (props: React.ComponentProps<typeof ShadcnAvatarImage>) => (
  <ShadcnAvatarImage {...props} />
);

const AvatarFallback = (
  props: React.ComponentProps<typeof ShadcnAvatarFallback>
) => <ShadcnAvatarFallback {...props} />;

const AvatarBadge = (props: React.ComponentProps<typeof ShadcnAvatarBadge>) => (
  <ShadcnAvatarBadge {...props} />
);

const AvatarGroup = (props: React.ComponentProps<typeof ShadcnAvatarGroup>) => (
  <ShadcnAvatarGroup {...props} />
);

const AvatarGroupCount = (
  props: React.ComponentProps<typeof ShadcnAvatarGroupCount>
) => <ShadcnAvatarGroupCount {...props} />;

export {
  Avatar,
  AvatarImage,
  AvatarFallback,
  AvatarBadge,
  AvatarGroup,
  AvatarGroupCount,
};
